
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/registries/[registryUri]/gift",
      function () {
        return require("private-next-pages/registries/[registryUri]/gift/index.page.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/registries/[registryUri]/gift"])
      });
    }
  